import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Box, CssBaseline } from '@mui/material';

// Global Styles
import './styles/global.css';
import GlobalResponsiveStyles from './components/common/GlobalResponsiveStyles';

// Components
import ScrollToTop from './components/common/ScrollToTop';

// Contexts
import { AuthProvider } from './contexts/AuthContext';

// Layouts
import MainLayout from './layouts/MainLayout';
import DashboardLayout from './layouts/DashboardLayout';

// Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import FleetPage from './pages/FleetPage';
import BookingPage from './pages/BookingPage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import NotFoundPage from './pages/NotFoundPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import FaqPage from './pages/FaqPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import TestimonialsPage from './pages/TestimonialsPage';

// Dashboard Pages
import DashboardPage from './pages/dashboard/DashboardPage';
import BookingHistoryPage from './pages/dashboard/BookingHistoryPage';
import ProfilePage from './pages/dashboard/ProfilePage';
import TeamManagementPage from './pages/dashboard/TeamManagementPage';
import BillingPage from './pages/dashboard/BillingPage';

function App() {
  // Set viewport meta tag for proper mobile display
  useEffect(() => {
    // Check if viewport meta tag exists
    let viewportMeta = document.querySelector('meta[name="viewport"]');
    
    // If it doesn't exist, create one
    if (!viewportMeta) {
      viewportMeta = document.createElement('meta');
      viewportMeta.setAttribute('name', 'viewport');
      document.head.appendChild(viewportMeta);
    }
    
    // Set the content attribute to ensure proper mobile scaling
    viewportMeta.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes'
    );
    
    // Cleanup function - don't remove the viewport tag since it might be needed
    // by other parts of the app, but we could reset it if needed
    return () => {};
  }, []);

  return (
    <AuthProvider>
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <CssBaseline />
      <GlobalResponsiveStyles />
      <ScrollToTop />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<MainLayout />}>
            <Route index element={<HomePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="services" element={<ServicesPage />} />
            <Route path="fleet" element={<FleetPage />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="booking" element={<BookingPage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="register" element={<RegisterPage />} />
              <Route path="forgot-password" element={<ForgotPasswordPage />} />
              <Route path="terms" element={<TermsOfServicePage />} />
              <Route path="privacy" element={<PrivacyPolicyPage />} />
              <Route path="faqs" element={<FaqPage />} />
              <Route path="testimonials" element={<TestimonialsPage />} />
          </Route>
          
          {/* Dashboard Routes */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardPage />} />
            <Route path="bookings" element={<BookingHistoryPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="team" element={<TeamManagementPage />} />
            <Route path="billing" element={<BillingPage />} />
          </Route>
          
          {/* 404 Route */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Box>
    </Box>
    </AuthProvider>
  );
}

export default App;
